export const config = {
  keycloakUrl: process.env.REACT_APP_KEYCLOAK_URL || 'http://localhost:8080',
  keycloakRealm: process.env.REACT_APP_KEYCLOAK_REALM || 'salesbotics',
  platformClientId:
    process.env.REACT_APP_KEYCLOAK_PLATFORM_CLIENT || 'salesbotics-platform',
  tenantClientId:
    process.env.REACT_APP_KEYCLOAK_TENANT_CLIENT || 'salesbotics-tenant',
  platformApiUrl: process.env.REACT_APP_PLATFORM_API_URL || 'http://localhost:8001',
  tenantApiUrl: process.env.REACT_APP_TENANT_API_URL || 'http://localhost:8000',
  shopApiUrl:
    process.env.REACT_APP_SHOP_API_URL ||
    process.env.REACT_APP_TENANT_API_URL ||
    'http://localhost:8000',
  storefrontDomainSuffix:
    process.env.REACT_APP_STOREFRONT_DOMAIN_SUFFIX || 'salesy.store',
};
